<template>
    <div>
        <loading :active.sync="loadingScreen"
                 :can-cancel="canCancel"
                 :is-full-page="fullPage"
                 color="#2dcecc"
                 :opacity="opacity"
        >

        </loading>
        <fade-transition :duration="200" origin="center top" mode="out-in">
            <!-- your content here -->
            <router-view></router-view>
        </fade-transition>
    </div>

</template>

<script>
    import { FadeTransition } from 'vue2-transitions';
    import loading from 'vue-loading-overlay';
    import $ from 'jquery';
    import { mapGetters } from 'vuex';

    export default {
        name: "InheritLayout",
        computed: {
            ...mapGetters([
                'loadingScreen',
             ]),
        },
        components: {
            FadeTransition,
            loading,

        },
        data() {
            return {
                mobileView: true,
                opacity:1,
                canCancel:false,
                fullPage: false,
            };
        },
        methods: {
            handleView() {
            this.mobileView = window.innerWidth <= 990;
            },
            created() {
                this.handleView();
                window.addEventListener('resize', this.handleView);
                let self = this;
                $("body").on("mousemove",function(evt) {
                let dernierActivite = new Date(localStorage.getItem('activite'));
                let nouvelleActivite = new Date(moment());
                let difference = Math.abs(Math.round(((nouvelleActivite - dernierActivite) / 1000 ) / 60));
                localStorage.setItem('ancestor_link', window.location.href);
                if (difference <30){
                    localStorage.setItem('activite', moment());
                }else{
                    evt.preventDefault();
                    $("body").off("mousemove");
                    if(!window.location.href.includes('/login')){
                    localStorage.setItem('ancestor_link', window.location.href);
                    }
                    self.logOut();
                }
                });
            },
            logOut(){
                let args = {
                user: localStorage.getItem('user')
                };

                let successMessage = this.$i18n.t('message.disconnectMessage');
                let errorMessages = {
                generic: this.$i18n.t('message.genericError'),
                error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };
                this.$store.dispatch('logoutHandler',{args, errorMessages, successMessage});
            },
        }
        
    }
</script>

<style scoped>
    @import '~vue-loading-overlay/dist/vue-loading.css';
</style>